module.exports = __webpack_public_path__ + "static/media/uir.578d8d1a.png";